import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("rect", {
        width: "11",
        height: "11",
        rx: "1.5",
        fill: "currentColor"
      }),
      _createElementVNode("rect", {
        x: "13",
        width: "11",
        height: "11",
        rx: "1.5",
        fill: "currentColor"
      }),
      _createElementVNode("rect", {
        y: "13",
        width: "11",
        height: "11",
        rx: "1.5",
        fill: "currentColor"
      }),
      _createElementVNode("rect", {
        x: "13",
        y: "13",
        width: "11",
        height: "11",
        rx: "1.5",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }